import * as yup from 'yup'

export type ShippingPackage = {
  id?: string
  name: string
  dimension: {
    height: number | ''
    width: number | ''
    units: any
    length: number | ''
  }
  weight: {
    value: number | ''
    units: any
  }
}

export const shippingInitialState: ShippingPackage = {
  name: '',
  dimension: {
    height: '',
    width: '',
    length: '',
    units: 'INCHES',
  },
  weight: {
    value: '',
    units: 'lb',
  },
}

export const ShippingPackageValidationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required('Package Name is required')
    .max(199, 'Package name maximum 200 characters'),
  dimension: yup.object().shape({
    width: yup.number().required('Width is required'),
    height: yup.number().required('Height is Required'),
    length: yup.number().required('Length is required'),
  }),
  weight: yup.object().shape({
    value: yup.number().required('Weight is required'),
  }),
})

export default ShippingPackage
